<template>
  <div class="container" v-if="isFinsh">
    <div class="headerView flex-row">
      <div class="headerTitle">
        <img class="logo" src="../../assets/images/fangxin_logo.png" alt="" />
        <div class="title flex-row items-center">放鑫钱包</div>
        <div class="header-line self-center"></div>
        <div class="subtitle flex-row items-center">专业一站式借款平台</div>
      </div>
      <div class="headerTip">
        <div class="headerTip-text">完成资料认证 享受</div>
        <div class="headerTip-text1">精选产品</div>
        <div class="headerTip-img"></div>
      </div>
    </div>

    <div class="userView">
      <div class="infoTitleView">
        <div class="infoTitle-line"></div>
        <div class="infoTitle-text">身份信息</div>
      </div>
      <div class="register-form">
        <!-- 姓名 -->
        <van-cell-group
          class="inp-elem-box"
          v-show="formShowControl.isShowName"
        >
          <van-field
            v-model.trim="form.userName"
            maxlength="4"
            label="    真实姓名"
            required
            class="inp-elem-info"
            placeholder="请输入您的真实姓名"
            @blur="handleBlur(0)"
            clearable
          />
        </van-cell-group>

        <!-- 年龄 -->
        <van-cell-group class="inp-elem-box" v-show="formShowControl.isShowAge">
          <van-field
            v-model.trim="form.age"
            label="真实年龄"
            required
            type="digit"
            maxlength="2"
            class="inp-elem-info"
            placeholder="年龄在22岁-55岁均可申请"
            @blur="handleBlur(1)"
            clearable
          />
        </van-cell-group>
        <!-- 身份证号 -->
        <van-cell-group
          class="inp-elem-box"
          v-show="formShowControl.isShowIdCard"
        >
          <van-field
            v-model.trim="form.idCard"
            label="身份证号"
            type="text"
            maxlength="18"
            required
            class="inp-elem-info"
            placeholder="请输入身份证号"
            @blur="handleBlur(2)"
            clearable
          />
        </van-cell-group>
        <!-- 所在城市 -->
        <van-cell-group class="inp-elem-box">
          <van-field
            v-model.trim="addressPositionName"
            right-icon="arrow"
            label="所在城市"
            required
            type="digit"
            maxlength="2"
            disabled
            class="inp-elem-info"
            @click="handleClickPosition"
          />
        </van-cell-group>
      </div>
    </div>

    <div class="infoView">
      <div class="sex" v-show="formShowControl.isShowSex">
        <div class="inp-elem-box inp-elem tags">
          <div class="infoTitleView">
            <div class="infoTitle-line"></div>
            <div class="infoTitle-text">性别</div>
          </div>
          <van-row :gutter="15">
            <van-col
              v-for="(item, index) in formItemData.isShowSex"
              :key="index"
              :class="item.active ? 'active' : ''"
              span="12"
              @click="handleChooseSex(index)"
            >
              <div class="u-flex u-col-center u-row-center">
                {{ item.dictLabel }}
              </div>
            </van-col>
          </van-row>
        </div>
      </div>
      <div
        class="info-item"
        v-show="
          (formShowControl.isShowLoanMount &&
            selectStatus.isSelectLoanAmount) ||
          !formShowControl.isShowSex
        "
      >
        <div class="inp-elem-box inp-elem tags">
          <div class="infoTitleView">
            <div class="infoTitle-line"></div>
            <div class="infoTitle-text">借多少(元)</div>
          </div>
          <van-row :gutter="15">
            <van-col
              v-for="(item, index) in formItemData.isShowLoanMount"
              :key="index"
              :class="item.active ? 'active' : ''"
              span="12"
              @click="handleChooseLoanMount(index)"
            >
              <div class="u-flex u-col-center u-row-center">
                {{ item.dictLabel }}
              </div>
            </van-col>
          </van-row>
        </div>
      </div>
      <!-- 用途 -->
      <div
        class="info-item"
        v-show="
          formShowControl.isShowLoanPurpose && selectStatus.isSelectLoanPurpose
        "
      >
        <div class="inp-elem-box inp-elem tags">
          <div class="infoTitleView">
            <div class="infoTitle-line"></div>
            <div class="infoTitle-text">借款用途</div>
          </div>
          <van-row :gutter="15">
            <van-col
              v-for="(item, index) in formItemData.isShowLoanPurpose"
              :key="index"
              :class="item.active ? 'active' : ''"
              span="12"
              @click="handleChooseLoanPurpose(index)"
            >
              <div class="u-flex u-col-center u-row-center">
                {{ item.dictLabel }}
              </div>
            </van-col>
          </van-row>
        </div>
      </div>
      <!-- 借多久(月) -->
      <div
        class="info-item"
        v-show="
          formShowControl.isShowLoanTime &&
          selectStatus.isSelectLoanPeriod &&
          period === undefined
        "
      >
        <div class="inp-elem-box inp-elem tags">
          <div class="infoTitleView">
            <div class="infoTitle-line"></div>
            <div class="infoTitle-text">借多久(月)</div>
          </div>
          <van-row :gutter="15">
            <van-col
              v-for="(item, index) in formItemData.isShowLoanTime"
              :key="index"
              :class="item.active ? 'active' : ''"
              span="12"
              @click="handleChooseLoanTime(index)"
            >
              <div class="u-flex u-col-center u-row-center">
                {{ item.dictLabel }}
              </div>
            </van-col>
          </van-row>
        </div>
      </div>
      <!-- 资产信息(多选) -->
      <div
        class="info-item"
        v-show="
          formShowControl.isShowAssetsFields && selectStatus.isSelectAssets
        "
      >
        <div class="inp-elem-box inp-elem tags">
          <div class="infoTitleView">
            <div class="infoTitle-line"></div>
            <div class="infoTitle-text">资产信息(多选)</div>
            <div class="label-tip">(多选提交真实资质项可提高审核通过率)</div>
          </div>

          <van-row :gutter="15">
            <van-col
              v-for="(item, index) in formItemData.isShowAssetsFields"
              :key="index"
              :class="item.active ? 'active' : ''"
              span="12"
              @click="handleChooseAssetsInfo(index)"
            >
              <div class="u-flex u-col-center u-row-center">
                {{ item.dictLabel }}
              </div>
            </van-col>
          </van-row>
        </div>
      </div>
      <!-- 芝麻分(单选) -->
      <div
        class="info-item"
        v-show="formShowControl.isShowAuthFields && selectStatus.isSelectCredit"
      >
        <div class="inp-elem-box inp-elem tags">
          <div class="infoTitleView">
            <div class="infoTitle-line"></div>
            <div class="infoTitle-text">芝麻分(单选)</div>
          </div>
          <van-row :gutter="15">
            <van-col
              v-for="(item, index) in formItemData.isShowAuthFields"
              :key="index"
              :class="item.active ? 'active' : ''"
              span="12"
              @click="handleChooseCredit(index)"
            >
              <div class="u-flex u-col-center u-row-center">
                {{ item.dictLabel }}
              </div>
            </van-col>
          </van-row>
        </div>
      </div>
      <!-- 京东白条(单选) -->
      <div
        class="info-item"
        v-show="
          formShowControl.isShowJdIousFields && selectStatus.isSelectJddept
        "
      >
        <div class="inp-elem-box inp-elem tags">
          <div class="infoTitleView">
            <div class="infoTitle-line"></div>
            <div class="infoTitle-text">京东白条(单选)</div>
          </div>
          <van-row :gutter="15">
            <van-col
              v-for="(item, index) in formItemData.isShowJdIousFields"
              :key="index"
              :class="item.active ? 'active' : ''"
              span="12"
              @click="handleChooseJddept(index)"
            >
              <div class="u-flex u-col-center u-row-center">
                {{ item.dictLabel }}
              </div>
            </van-col>
          </van-row>
        </div>
      </div>
      <!-- 教育程度(单选) -->
      <div
        class="info-item"
        v-show="
          formShowControl.isShowEducation && selectStatus.isSelectEducation
        "
      >
        <div class="inp-elem-box inp-elem tags">
          <div class="infoTitleView">
            <div class="infoTitle-line"></div>
            <div class="infoTitle-text">教育程度(单选)</div>
          </div>
          <van-row :gutter="15">
            <van-col
              v-for="(item, index) in formItemData.isShowEducation"
              :key="index"
              :class="item.active ? 'active' : ''"
              span="12"
              @click="handleChooseEducation(index)"
            >
              <div class="u-flex u-col-center u-row-center">
                {{ item.dictLabel }}
              </div>
            </van-col>
          </van-row>
        </div>
      </div>
      <!-- 婚姻状况(单选) -->
      <div
        class="info-item"
        v-show="formShowControl.isShowMarry && selectStatus.isSelectMarriage"
      >
        <div class="inp-elem-box inp-elem tags">
          <div class="infoTitleView">
            <div class="infoTitle-line"></div>
            <div class="infoTitle-text">婚姻状况(单选)</div>
          </div>
          <van-row :gutter="15">
            <van-col
              v-for="(item, index) in formItemData.isShowMarry"
              :key="index"
              :class="item.active ? 'active' : ''"
              span="12"
              @click="handleChooseMarry(index)"
            >
              <div class="u-flex u-col-center u-row-center">
                {{ item.dictLabel }}
              </div>
            </van-col>
          </van-row>
        </div>
      </div>
      <!-- 职业身份(单选) -->
      <div
        class="info-item"
        v-show="
          formShowControl.isShowProfession && selectStatus.isSelectProfession
        "
      >
        <div class="inp-elem-box inp-elem tags">
          <div class="infoTitleView">
            <div class="infoTitle-line"></div>
            <div class="infoTitle-text">职业身份(单选)</div>
          </div>
          <van-row :gutter="15">
            <van-col
              v-for="(item, index) in formItemData.isShowProfession"
              :key="index"
              :class="item.active ? 'active' : ''"
              span="12"
              @click="handleChooseProfession(index)"
            >
              <div class="u-flex u-col-center u-row-center">
                {{ item.dictLabel }}
              </div>
            </van-col>
          </van-row>
        </div>
      </div>
      <!-- 提交 -->
      <button
        class="btn-submit"
        v-prevent-reclick
        v-show="selectStatus.isShowButton"
        @click="handleSubmit"
      >
        获取额度
      </button>
      <div class="bottom_view" v-show="selectStatus.isShowButton">
        <img
          class="bottom_icon"
          src="../../assets/images/model8/bottom_icon.png"
        />
        <span class="text-group_1">
          信息仅用于核验,合作机构评估,您的信息将被加密保护
        </span>
      </div>
    </div>

    <!-- 工作城市下拉选 -->
    <van-popup
      v-model="showPickerCity"
      position="bottom"
      safe-area-inset-bottom
      round
    >
      <van-picker
        show-toolbar
        title="请选择工作城市"
        :columns="areaList"
        @change="onCityChange"
        @confirm="onAreaConfirm"
        @cancel="showPickerCity = false"
        value-key="localName"
      />
    </van-popup>
    <!-- 弹窗 -->
    <!--    <div class="pop-bg flex-col" v-show="showPopProduct" v-if="this.product">-->
    <div class="pop-overlay" v-show="showPopProduct">
      <div class="pop-bg">
        <div class="pop-product">
          <img class="pop-logo" :src="productLogo" alt="" />
          <div class="pop-title flex-row items-center">
            {{ this.product.productName }}
          </div>
        </div>
        <div class="pop-subtitle flex-row items-center">{{ this.feature }}</div>
        <div class="checkView justify-between">
          <van-checkbox v-model="rpChecked" shape="square" icon-size="17px">
          </van-checkbox>
          <div class="text-wrapper_10">
            <span class="text_20">我已阅读并同意</span>
            <span class="text_21" @click.stop="handleProtocol(9)"
              >《用户个人信息共享授权协议》</span
            >
          </div>
        </div>
        <div class="pop-btn">
          <div class="pop-cancel" @click="clickCancel"></div>
          <div class="pop-confirm" @click="clickConfirm"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script src="././public/js/base.js"></script>
<script>
import SharePop from "@/components/SharePop";
import myBMap from "../../utils/myBMap";
import * as API_Common from "@/api/common.js";
import { Dialog } from "vant";
import { toRedirectUrlAndSaveRecordNoDebounce } from "@/api/common.js";
import { replace, filtion } from "verification-sensitive";

//返回弹窗
history.pushState(null, null, window.location.href);
setTimeout(() => {
  window.addEventListener("popstate", (e) => processRetain(e));
}, 500);

const processRetain = () => {
  // 这个函数内控制弹窗的显示，处理相关业务逻辑
  if (this.product.productName) {
    this.showPopProduct = true;
  }
};

export default {
  name: "userForm",
  components: {
    SharePop,
  },
  data() {
    return {
      isFinsh: false,
      positionStatus: false,
      displayCityName: "",
      showPopProduct: false,
      rpChecked: true,
      address: {
        province: "",
        city: "",
      },
      areaList: [{ values: [] }, { values: [] }],
      showPickerCity: false,
      redirect: this.$route.query.redirect,
      created: this.$route.query.created,
      code: this.$route.query.code,
      tid: this.$route.query.tid,
      source: this.$route.query.source,
      period: this.$route.query.period, //借款期限
      isShowView: false,
      feature: "", //弹窗特点
      productLogo: "",
      form: {
        channelNo: this.$route.query.source,
        userName: "",
        idCard: "",
        age: "",
        sex: "", //1：男，2：女
        jddept: "", //白条
        assets: [], //资产信息
        loanAmount: "", //借多少
        loanPeriod: "", //借多久
        loanPurpose: "", //借款用途
        credit: "", //芝麻分
        marriage: "", //婚姻
        education: "", //学历
        gpsCityName: "",
        cityId: "",
        provinceId: "",
        profession: "",
      },
      amount: {},
      gpsRecord: {
        userId: 0,
        channelCode: "",
        provinceName: "",
        cityName: "",
        longitude: "",
        latitude: "",
        gpsDetail: "",
        status: 0,
      },
      selectStatus: {
        isSelectSex: false, //1：男，2：女
        isSelectJddept: false, //白条
        isSelectAssets: false, //资产信息
        isSelectLoanAmount: false, //借多少
        isSelectLoanPeriod: false, //借多久
        isSelectLoanPurpose: false, //借款用途
        isSelectCredit: false, //芝麻分
        isSelectMarriage: false, //婚姻
        isSelectEducation: false, //学历
        isSelectProfession: false, //职业
        isShowButton: false,
      },
      product: {
        //产品名字
        productName: "",
        //产品icon
        logo: "",
        //产品icon占位图
        productPlaceHolder:
          "https://lanhu-dds-backend.oss-cn-beijing.aliyuncs.com/merge_image/imgs/8d4f87aba9e348a0b8a48a06a914d47e_mergeImage.png",
        //产品最高额度
        loanAmount: "",
        //产品利率
        loanRate: "",
        prodFeature: "",
        isToRegister: undefined,
        hitRecordId: undefined,
      },
      productList: [],
      formShowControl: {
        isShowName: false,
        isShowIdCard: false,
        isShowLoanMount: false,
        isShowLoanTime: false,
        isShowLoanPurpose: false,
        isShowAuthFields: false,
        isShowJdIousFields: false,
        isShowEducation: false,
        isShowAssetsFields: false,
        isShowMarry: false,
        isShowSex: false,
      },
      formItemData: {
        isShowLoanMount: [
          { dictValue: 1, dictLabel: "1-5万" },
          { dictValue: 2, dictLabel: "5-10万" },
          { dictValue: 3, dictLabel: "10-20万" },
          { dictValue: 4, dictLabel: "20万以上" },
        ],
        //借多久(月)
        isShowLoanTime: [
          { dictValue: 1, dictLabel: "3" },
          { dictValue: 2, dictLabel: "6" },
          { dictValue: 3, dictLabel: "9" },
          { dictValue: 4, dictLabel: "12" },
        ],
        //借款用途
        isShowLoanPurpose: [
          { dictValue: 1, dictLabel: "日常消费" },
          { dictValue: 2, dictLabel: "装修贷款" },
          { dictValue: 3, dictLabel: "医疗贷款" },
          { dictValue: 4, dictLabel: "旅游贷款" },
          { dictValue: 5, dictLabel: "买车贷款" },
        ],
        isShowSex: [
          { dictValue: 1, dictLabel: "男" },
          { dictValue: 2, dictLabel: "女" },
        ],
        //资产信息(多选)
        isShowAssetsFields: [
          { dictValue: 1, dictLabel: "房产" },
          { dictValue: 2, dictLabel: "车产" },
          { dictValue: 3, dictLabel: "公积金" },
          { dictValue: 4, dictLabel: "社保" },
          { dictValue: 5, dictLabel: "商业保险" },
          { dictValue: 6, dictLabel: "企业主" },
        ],
        //芝麻分(单选)
        isShowAuthFields: [
          { dictValue: 1, dictLabel: "600以下" },
          { dictValue: 2, dictLabel: "600-650" },
          { dictValue: 3, dictLabel: "650-700" },
          { dictValue: 4, dictLabel: "700以上" },
          { dictValue: 5, dictLabel: "无" },
        ],
        //京东白条(单选)
        isShowJdIousFields: [
          { dictValue: 1, dictLabel: "5000以下" },
          { dictValue: 2, dictLabel: "5000以上" },
          { dictValue: 0, dictLabel: "无" },
        ],
        //教育程度(单选)
        isShowEducation: [
          { dictValue: 1, dictLabel: "硕士及以上" },
          { dictValue: 2, dictLabel: "本科" },
          { dictValue: 3, dictLabel: "大专" },
          { dictValue: 4, dictLabel: "高中" },
          { dictValue: 5, dictLabel: "中专" },
          { dictValue: 6, dictLabel: "初中及以下" },
        ],

        //婚姻状况(单选)
        isShowMarry: [
          { dictValue: 1, dictLabel: "未婚" },
          { dictValue: 2, dictLabel: "已婚" },
          { dictValue: 3, dictLabel: "离异" },
        ],
        //职业身份(单选)
        isShowProfession: [
          { dictLabel: "上班族", dictValue: "上班族" },
          { dictLabel: "企业主", dictValue: "企业主" },
          { dictLabel: "自由职业", dictValue: "自由职业" },
          { dictLabel: "公务员/事业/国企", dictValue: "公务员/事业/国企" },
          // { dictValue: 1, dictLabel: "上班族" },
          // { dictValue: 2, dictLabel: "个体工商户" },
          // { dictValue: 3, dictLabel: "自由职业者" },
          // { dictValue: 4, dictLabel: "退休/待业/ 无业" },
          // { dictValue: 5, dictLabel: "在校学生" },
          // { dictValue: 6, dictLabel: "农民" },
          // { dictValue: 7, dictLabel: "私营业主" },
        ],
      },
      regTest: {
        regUserName: /^[\u4e00-\u9fa5]{2,6}$/,
        regIdcard:
          /^[1-9]\d{5}(18|19|20|(3\d))\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,
      },
      h5LoanRemindDesc: "",
      companys: "",
      showBackBtn: false, //无产品不显示返回按钮
      // timerUpdate: undefined,
      // timerUpdate5: undefined,
      // timerUpdate10: undefined,
      // timerUpdate30: undefined,
      // timerUpdate60: undefined,
    };
  },

  mounted() {
    localStorage.removeItem("isPopupProduct");
    localStorage.removeItem("isPushAuth");

    if (this.$route.query.lendul) {
      window.localStorage.setItem("lendul", this.$route.query.lendul);
    } else {
      window.localStorage.removeItem("lendul");
    }

    this.queryFormItem();
    this.getRiskWarningText();
    this.getProtocol();
    this.requestPopupProduct();
    this.channelIncomingControl();
    this.handleUserResidenceTime();
    // 按需使用：A→B→C就需要页面一进来的时候，就添加一个历史记录
    window.history.pushState(null, null, document.URL);
    // // 给window添加一个popstate事件，拦截返回键，执行this.onBrowserBack事件，addEventListener需要指向一个方法
    window.addEventListener("popstate", this.onBrowserBack, false);
  },
  destroyed() {
    // 当页面销毁必须要移除这个事件，vue不刷新页面，不移除会重复执行这个事件
    window.removeEventListener("popstate", this.onBrowserBack, false);
  },
  watch: {
    // 弹框监听，当弹框显示的时候，pushState添加一个历史，供返回键使用
    PopupShow: {
      handler(newVal, oldVal) {
        if (newVal.Terms === true) {
          window.history.pushState(null, null, document.URL);
        }
      },
      deep: true,
    },
  },
  computed: {
    addressPositionName() {
      if (this.positionStatus) {
        return `${this.address.province} ${this.address.city}`;
      } else {
        if (this.form.gpsCityName) {
          return this.form.gpsCityName;
        } else {
          return "";
        }
      }
    },
  },
  methods: {
    onBrowserBack() {
      // 这里写点击返回键时候的事件
      // 比如判断需求执行back()或者go(-2)或者PopupShow=false隐藏弹框
      if (this.product.productName) {
        this.showPopProduct = true;
      }
    },

    checkPosition() {
      if (navigator.geolocation) {
        this.initBMap();
      } else {
        this.$toast("当前浏览器不支持定位，请手动选择定位");
        this.manualPosition();
      }
    },

    initBMap() {
      let that = this;
      myBMap.getLocations(
        (address, latitude, longitude) => {
          that.positionStatus = true;
          that.address.province = address.province;
          that.address.city = address.city;
          that.form.gpsCityName = address.city;
          that.gpsRecord.longitude = longitude;
          that.gpsRecord.latitude = latitude;
          that.gpsRecord.gpsDetail = address.gpsDetail;
          that.gpsRecord.status = 1;
        },
        (error) => {
          that.$toast.fail("定位失败，请手动选择城市");
          that.manualPosition();
        }
      );
    },

    manualPosition() {
      this.positionStatus = false;
    },

    handleClickPosition() {
      if (!this.positionStatus) {
        this.getArea(0, 0);
        this.showPickerCity = true;
      }
    },
    //姓名 年龄校验
    handleBlur(index) {
      switch (index) {
        case 0:
          API_Common.delayModel8SUpdate(this.source, 0, this.tid, 11);
          if (this.form.userName !== "") {
            if (!this.regTest.regUserName.test(this.form.userName)) {
              this.$toast("请输入正确的姓名");
            }
          }
          break;
        case 1:
          API_Common.delayModel8SUpdate(this.source, 0, this.tid, 12);
          if (!this.form.age || this.form.age == "") {
            this.form.age = "";
            this.$toast("请输入年龄");
            this.amount.age = 0;
          } else if (
            parseInt(this.form.age) < 22 ||
            parseInt(this.form.age) > 55
          ) {
            this.$toast("您的年龄不符合申请要求");
            this.form.age = "";
            this.amount.age = 0;
          }
          break;
        case 2:
          if (this.form.idCard !== "") {
            if (
              !this.regTest.regIdcard.test(this.form.idCard) ||
              !this.validateIDCard(this.form.idCard)
            ) {
              this.$toast("请输入正确的身份证号码");
            }
          }
          break;
      }
    },
    validateIDCard(idCard) {
      const weights = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
      const checkCodes = [
        "1",
        "0",
        "X",
        "9",
        "8",
        "7",
        "6",
        "5",
        "4",
        "3",
        "2",
      ];
      let sum = 0;
      for (let i = 0; i < 17; i++) {
        sum += parseInt(idCard.charAt(i)) * weights[i];
      }
      const mod = sum % 11;
      const checkCode = checkCodes[mod];
      return idCard.charAt(17).toUpperCase() === checkCode;
    },

    //查询需要填写的进件资料
    channelIncomingControl() {
      API_Common.channelIncomingControl(this.form.channelNo).then((res) => {
        if (res.code === 200) {
          this.formShowControl = res.data;
          this.checkPosition();
        }
      });
    },
    handleSubmit() {
      API_Common.delayModel8SUpdate(this.source, 0, this.tid, 17);
      if (this.period) {
        this.form.loanPeriod = this.period;
      }
      if (!this.positionStatus && !this.form.cityId) {
        this.$toast("请选择您所在的城市");
        return;
      } else if (this.form.userName === "" && this.formShowControl.isShowName) {
        this.$toast("请输入姓名");
        return;
      } else if (
        !this.regTest.regUserName.test(this.form.userName) &&
        this.formShowControl.isShowName
      ) {
        this.$toast("请输入合法的姓名");
        return;
      }
      if (this.form.age === "" && this.formShowControl.isShowAge) {
        this.$toast("请输入年龄");
        return;
      }
      if (this.form.idCard === "" && this.formShowControl.isShowIdCard) {
        this.$toast("请输入身份证号");
        return;
      } else if (
        !this.regTest.regIdcard.test(this.form.idCard) &&
        this.formShowControl.isShowIdCard
      ) {
        this.$toast("请输入合法的身份证号");
        return;
      }

      if (this.form.sex === "" && this.formShowControl.isShowSex) {
        this.$toast("请选择性别");
        return;
      }

      if (this.form.loanAmount === "" && this.formShowControl.isShowLoanMount) {
        this.$toast("请选择借多少");
        return;
      }
      if (this.form.loanPeriod === "" && this.formShowControl.isShowLoanTime) {
        this.$toast("请选择借多久");
        return;
      }
      if (
        this.form.loanPurpose === "" &&
        this.formShowControl.isShowLoanPurpose
      ) {
        this.$toast("请选择借款用途");
        return;
      }
      this.formItemData.isShowAssetsFields.map((i) => {
        if (i.active) {
          this.form.assets.push(i.dictValue);
        }
      });
      if (
        this.form.assets.length === 0 &&
        this.formShowControl.isShowAssetsFields
      ) {
        this.$toast("请至少选择一项资产");
        return;
      }
      if (this.form.credit === "" && this.formShowControl.isShowAuthFields) {
        this.$toast("请选择芝麻分");
        return;
      }
      if (!this.form.jddept && this.formShowControl.isShowJdIousFields) {
        this.$toast("请选择京东白条");
        return;
      }

      if (this.form.education === "" && this.formShowControl.isShowEducation) {
        this.$toast("请选择教育程度");
        return;
      }
      if (this.form.marriage === "" && this.formShowControl.isShowMarry) {
        this.$toast("请选择婚姻状况");
        return;
      }
      if (
        this.form.profession === "" &&
        this.formShowControl.isShowProfession
      ) {
        this.$toast("请选择婚姻状况");
        return;
      }
      // let flag = filtion(this.form.userName);
      // if (flag) {
      //   this.$toast("请输入合法的姓名");
      //   return;
      // }
      this.addGpsRecord();
      let datas = {
        ...this.form,
        ...{
          userName: this.form.userName,
        },
      };
      let fun = "submitAnEntry";

      API_Common[fun](datas).then((res) => {
        if (res.code === 200 || res.msg == "insertExisit") {
          // clearTimeout(this.timerUpdate);
          // clearTimeout(this.timerUpdate5);
          // clearTimeout(this.timerUpdate10);
          // clearTimeout(this.timerUpdate30);
          // clearTimeout(this.timerUpdate60);
          API_Common.delayModel8SUpdate(this.source, 0, this.tid, 4);
          this.submitFormNextGoPage();
        } else {
          this.$toast(res.msg);
        }
      });
    },
    //上传gps定位
    addGpsRecord() {
      let userId = window.localStorage.getItem("userId");
      this.gpsRecord.userId = userId ? userId : 0;
      this.gpsRecord.channelCode = this.source;
      this.gpsRecord.provinceName = this.address.province;
      this.gpsRecord.cityName = this.address.city;
      this.gpsRecord.gpsDetail = this.gpsRecord.gpsDetail || "定位失败";
      API_Common.addGpsRecord(this.gpsRecord).then((res) => {});
    },
    queryFormItem() {
      API_Common.queryFormItem().then((res) => {
        if (res.code == 200) {
          this.formItemData.credit = res.data.credit;
          this.computedActive(this.formItemData);
          this.isFinsh = true;
        } else {
          this.$toast(res.msg);
        }
      });
    },

    getRiskWarningText() {
      API_Common.queryRiskWarning(this.form.channelNo).then((res) => {
        if (res.code == 200) {
          const { h5LoanRemindDesc } = res.data;
          this.h5LoanRemindDesc = h5LoanRemindDesc.replace(/[;；]/g, "\n");
        }
      });
    },

    computedActive(objs) {
      Object.keys(objs).forEach((key) => {
        let arr = objs[key];
        arr.map((item) => {
          item.active = false;
        });
      });
    },

    handleChooseSex(index) {
      API_Common.delayModel8SUpdate(this.source, 0, this.tid, 13);
      this.formItemData.isShowSex.map((item) => {
        item.active = false;
      });
      this.formItemData.isShowSex[index].active = true;
      this.form.sex = this.formItemData.isShowSex[index].dictValue;
      this.selectStatus.isSelectSex = true;
      this.selectStatus.isSelectLoanAmount = true;
      this.$forceUpdate();
    },
    //借多少钱
    handleChooseLoanMount(index) {
      API_Common.delayModel8SUpdate(this.source, 0, this.tid, 14);
      this.formItemData.isShowLoanMount.map((item) => {
        item.active = false;
      });
      this.formItemData.isShowLoanMount[index].active = true;
      this.form.loanAmount = this.formItemData.isShowLoanMount[index].dictLabel;
      this.selectStatus.isSelectLoanAmount = true;
      if (this.formShowControl.isShowLoanPurpose) {
        this.selectStatus.isSelectLoanPurpose = true;
      } else if (
        this.formShowControl.isShowLoanTime &&
        this.period === undefined
      ) {
        this.selectStatus.isSelectLoanPeriod = true;
      } else {
        this.selectStatus.isSelectAssets = true;
      }
      this.$forceUpdate();
    },
    //用途
    handleChooseLoanPurpose(index) {
      this.formItemData.isShowLoanPurpose.map((item) => {
        item.active = false;
      });
      this.formItemData.isShowLoanPurpose[index].active = true;
      this.form.loanPurpose =
        this.formItemData.isShowLoanPurpose[index].dictLabel;

      if (this.formShowControl.isShowLoanTime && this.period === undefined) {
        this.selectStatus.isSelectLoanPeriod = true;
      } else {
        this.selectStatus.isSelectAssets = true;
      }
      this.scrollToBottom();
      this.$forceUpdate();
    },
    //借多久
    handleChooseLoanTime(index) {
      this.formItemData.isShowLoanTime.map((item) => {
        item.active = false;
      });
      this.formItemData.isShowLoanTime[index].active = true;
      this.form.loanPeriod = this.formItemData.isShowLoanTime[index].dictLabel;
      this.selectStatus.isSelectAssets = true;
      this.scrollToBottom();
      this.$forceUpdate();
    },

    //资产信息
    handleChooseAssetsInfo(index) {
      API_Common.delayModel8SUpdate(this.source, 0, this.tid, 15);
      if (this.formItemData.isShowAssetsFields[index].active) {
        let arr = this.formItemData.isShowAssetsFields.filter(
          (item) => item.active
        );
        if (arr.length > 1) {
          this.formItemData.isShowAssetsFields[index].active = false;
        } else {
          this.$toast.fail("至少保留一项");
        }
      } else {
        this.formItemData.isShowAssetsFields[index].active = true;
      }
      if (this.formShowControl.isShowAuthFields) {
        this.selectStatus.isSelectCredit = true;
      } else if (this.formShowControl.isShowJdIousFields) {
        this.selectStatus.isSelectJddept = true;
      } else if (this.formShowControl.isShowEducation) {
        this.selectStatus.isSelectEducation = true;
      } else if (this.formShowControl.isShowMarry) {
        this.selectStatus.isSelectMarriage = true;
      } else if (this.formShowControl.isShowProfession) {
        this.selectStatus.isSelectProfession = true;
      } else {
        this.selectStatus.isShowButton = true;
      }
      this.$forceUpdate();
      this.scrollToBottom();
    },
    //芝麻分
    handleChooseCredit(index) {
      API_Common.delayModel8SUpdate(this.source, 0, this.tid, 16);
      this.formItemData.isShowAuthFields.map((item) => {
        item.active = false;
      });
      this.formItemData.isShowAuthFields[index].active = true;
      this.form.credit = this.formItemData.isShowAuthFields[index].dictLabel;
      if (this.formShowControl.isShowJdIousFields) {
        this.selectStatus.isSelectJddept = true;
      } else if (this.formShowControl.isShowEducation) {
        this.selectStatus.isSelectEducation = true;
      } else if (this.formShowControl.isShowMarry) {
        this.selectStatus.isSelectMarriage = true;
      } else if (this.formShowControl.isShowProfession) {
        this.selectStatus.isSelectProfession = true;
      } else {
        this.selectStatus.isShowButton = true;
      }
      this.$forceUpdate();
      this.scrollToBottom();
    },
    //京东白条
    handleChooseJddept(index) {
      this.formItemData.isShowJdIousFields.map((item) => {
        item.active = false;
      });
      this.formItemData.isShowJdIousFields[index].active = true;
      this.form.jddept = this.formItemData.isShowJdIousFields[index].dictValue;
      if (this.formShowControl.isShowEducation) {
        this.selectStatus.isSelectEducation = true;
      } else {
        this.selectStatus.isShowButton = true;
      }
      this.$forceUpdate();
    },

    //教育程度
    handleChooseEducation(index) {
      this.formItemData.isShowEducation.map((item) => {
        item.active = false;
      });
      this.formItemData.isShowEducation[index].active = true;
      this.form.education = this.formItemData.isShowEducation[index].dictLabel;
      this.selectStatus.isShowButton = true;
      this.$forceUpdate();
    },
    //婚姻
    handleChooseMarry(index) {
      this.formItemData.isShowMarry.map((item) => {
        item.active = false;
      });
      this.formItemData.isShowMarry[index].active = true;
      this.form.marriage = this.formItemData.isShowMarry[index].dictLabel;
      this.selectStatus.isSelectMarriage = true;
      this.$forceUpdate();
    },
    //职业
    handleChooseProfession(index) {
      this.formItemData.isShowProfession.map((item) => {
        item.active = false;
      });
      this.formItemData.isShowProfession[index].active = true;
      this.form.profession =
        this.formItemData.isShowProfession[index].dictLabel;
      this.selectStatus.isSelectProfession = true;
      this.$forceUpdate();
    },
    // 滚动到底部方法
    scrollToBottom() {
      setTimeout(() => {
        window.scrollTo({
          top: document.body.scrollHeight,
          behavior: "smooth", // 平滑滚动
        });
      }, 200);
    },

    getArea(parentId, index) {
      API_Common.getRegions(parentId).then((res) => {
        if (200 === res.code) {
          this.areaList[index].values = [{ localName: "请选择" }, ...res.data];
          this.areaList = [...this.areaList]; //更新areaList
          this.loading = false;
        } else {
          this.$toast.fail("获取省份失败");
        }
      });
    },

    onCityChange(picker, values, index) {
      if (values[index].localName === "请选择" && index !== 1) {
        this.areaList[1].values = [{ localName: "请选择" }];
      } else {
        if (!index) {
          this.getArea(values[0].id, index + 1); //传参 参数为上层选择的地区的id
        }
      }
    },

    onAreaConfirm(picker) {
      if (
        picker[0].localName === "请选择" ||
        picker[1].localName === "请选择"
      ) {
        this.$toast.fail("请选择完整的省市");
        return false;
      } else {
        this.form.gpsCityName = `${picker[0].localName} ${picker[1].localName}`;
        this.form.provinceId = picker[0].id;
        this.form.cityId = picker[1].id;
        this.showPickerCity = false;
      }
    },

    getProtocol() {
      Promise.all([
        API_Common.getContent({ pageType: 11 }),
        API_Common.getContent({ pageType: 10 }),
      ]).then((res) => {
        this.xxsq = res[0].data.content;
        this.zqgz = res[1].data.content;
      });
    },

    submitFormNextGoPage() {
      this.$router.replace({
        name: "userLoading",
        query: {
          source: this.form.channelNo,
          code: this.code,
        },
      });
    },

    //请求进件弹窗产品
    requestPopupProduct() {
      API_Common.getPopupProductList(this.form.channelNo).then((res) => {
        if (res.code == 200) {
          var list = res.data.list;
          if (list.length > 0) {
            this.product = list[0];
            this.productList = list;
            this.product.loanRate = this.product.loanRate + "%";
            this.productLogo = this.product.logo;
            if (this.product.prodFeature) {
              this.feature = this.product.prodFeature;
            } else {
              this.feature = "专业一站式借款平台";
            }
            this.showBackBtn = true;
          }
        }
      });
    },
    //弹窗继续填写
    clickCancel() {
      this.showPopProduct = false;
    },
    //     点击推荐产品立即申请
    clickConfirm() {
      if (!this.rpChecked) {
        this.$toast("请勾选同意协议及政策");
        return;
      }
      this.handleGoLink(this.product);
    },
    handleProtocol(pageType) {
      window.location.href = "/protocol.html?pageType=" + pageType;
      localStorage.setItem("isClickAuth", "YES");
    },
    handleGoLink(item) {
      const buriedData = {
        productId: item.productId,
        showPage: 5,
      };
      let redirectUrl = item.linkUrl; // 默认跳转 URL
      let isWeCom = item.isWeCom;
      if (item.isToRegister == 1) {
        API_Common.getRegister2CompanyUrl(item.productId, item.hitRecordId)
          .then((res) => {
            if (res.code === 200 && res.data) {
              redirectUrl = res.data;
            } else {
              console.warn("getRegister2CompanyUrl 返回数据异常，使用默认 URL");
            }
          })
          .catch((error) => {
            console.error("getRegister2CompanyUrl failed:", error);
          })
          .finally(() => {
            //无论api成功或者失败 都执行跳转和埋点
            toRedirectUrlAndSaveRecordNoDebounce(
              redirectUrl,
              buriedData,
              isWeCom
            );
          });
      } else {
        toRedirectUrlAndSaveRecordNoDebounce(redirectUrl, buriedData, isWeCom);
      }
    },

    //埋点 监听停留时间
    handleUserResidenceTime() {
      API_Common.delayModel8SUpdate(this.source, 0, this.tid, 2);
    },
  },
};
</script>

<style scoped>
@import "../../css/popupProduct.css"; /*引入公共样式*/
iframe {
  display: block;
}
</style>

<style lang="scss" scoped>
html,
body {
  overflow-x: hidden !important;
}

.container {
  height: 100vh;
  //overflow: auto;
  background-size: 100%;

  .van-overlay {
    z-index: 3;
  }
}

.headerView {
  width: 100%;
  margin-left: 0;
  margin-top: 0;
  background-image: url("../../assets/images/userForm/formHeader.png");
  background-size: cover; /* 背景图片覆盖整个元素区域 */
  background-position: center; /* 背景图片居中显示 */
  background-repeat: no-repeat; /* 背景图片不重复 */
}

.headerTitle {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-left: 1.95rem;
  margin-right: 1rem;
  height: 1.5rem;
}

.logo {
  width: 0.44rem;
  height: 0.44rem;
  border-radius: 0.01rem;
  background-size: cover; /* 背景图片覆盖整个元素区域 */
}

.title {
  font-family: Alibaba PuHuiTi, serif;
  font-weight: bold;
  font-size: 0.22rem;
  color: #ffffff;
  margin-left: 0.09rem;
}

.header-line {
  width: 0.01rem;
  height: 0.18rem;
  background-color: #ffffff;
  margin-left: 0.08rem;
}

.subtitle {
  font-family: Alibaba PuHuiTi, serif;
  font-size: 0.22rem;
  color: #ffffff;
  margin-left: 0.09rem;
}

.headerTip {
  display: flex;
  flex-direction: row;
  width: 5.48rem;
  height: 1.69rem;
  background: linear-gradient(0deg, #f35347, #ed3f33);
  border-radius: 0.3rem;
  border: 0.02px solid #ffffff;
  margin-left: 0.3rem;
  margin-top: 1.4rem;
}

.headerTip-text {
  margin-top: 0.3rem;
  margin-left: 0.29rem;
  font-family: Alibaba PuHuiTi, serif;
  font-size: 0.3rem;
  color: #ffffff;
}

.headerTip-text1 {
  margin-top: 0.3rem;
  font-family: Alibaba PuHuiTi, serif;
  font-size: 0.3rem;
  color: #ffbd76;
}

.headerTip-img {
  margin-left: 0.25rem;
  margin-top: 0.14rem;
  width: 0.53rem;
  height: 0.61rem;
  background-image: url("../../assets/images/userForm/headerTips.png");
  background-size: cover; /* 背景图片覆盖整个元素区域 */
  background-position: center; /* 背景图片居中显示 */
  background-repeat: no-repeat; /* 背景图片不重复 */
}

.userView {
  width: 6.87rem;
  min-height: 4rem;
  background: #ffffff;
  box-shadow: 0rem 0rem 1rem 0rem rgba(116, 116, 116, 0.18);
  border-radius: 0.4rem;
  margin-left: 0.3rem;
  margin-top: -0.7rem;
  padding-bottom: 0.2rem;
}

.infoTitleView {
  display: flex;
  justify-items: center;
  //height: 0.3rem;
}

.infoTitleView1 {
  display: flex;
  justify-items: center;
  margin-top: 0.2rem;
  height: 0.9rem;
}

.infoTitle-line {
  width: 0.05rem;
  height: 0.22rem;
  background: linear-gradient(179deg, #fce7c0, #ff544f);
  border-radius: 0.02rem;
  margin-left: 0.28rem;
  margin-top: 0.28rem;
}

.infoTitle-text {
  font-family: Alibaba PuHuiTi, serif;
  font-size: 0.3rem;
  color: #2c2c2c;
  line-height: 0.32rem;
  margin-left: 0.17rem;
  margin-top: 0.24rem;
}

.register-form {
  margin-top: 0;
  margin-left: 0.3rem;
  margin-right: 0.3rem;
}

.inp-elem-box {
  margin-bottom: 0.1rem;
  border-radius: 0.08rem;
}

.inp-elem {
  padding-left: 0.2rem;
  padding-right: 0.2rem;
  border-radius: 0.03rem;
}

.inp-elem-info {
  padding-left: 0.2rem;
  padding-right: 0.2rem;
  background-color: #fff5f4;
  border-radius: 0.03rem;
  height: 0.8rem;
  margin-top: 0.19rem;
}

.van-hairline--top-bottom::after {
  display: none;
}

.info-item {
}

.infoView {
  width: 6.87rem;
  background: #ffffff;
  box-shadow: 0 0 1rem 0 rgba(116, 116, 116, 0.18);
  border-radius: 0.4rem;
  margin-left: 0.3rem;
  margin-top: 0.36rem;
}

.tags {
  font-size: 0.31rem;
  color: #333333;
}

.van-col {
  > div {
    height: 0.8rem;
    width: 100%;
    margin-top: 0.1rem;
    margin-bottom: 0.18rem;
    border: 0.02rem solid #ecece7;
    border-radius: 0.15rem;
  }
}

//.van-cell {
//  padding: 8px 16px !important;
//}
.tags .active {
  > div {
    background: #ed3f33;
    border-color: #cccccc;
    color: #ffffff;
  }
}

.bottom_view {
  width: 100%;
  overflow-wrap: break-word;
  font-size: 0;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  text-align: left;
  white-space: nowrap;
  margin-left: 10px;
}

.label-tip {
  margin-left: 0.1rem;
  font-size: 0.2rem;
  font-weight: 400;
  margin-top: 0.28rem;
  color: #d93c3a;
}

.btn-submit {
  margin: 0.1rem 0;
  display: block;
  width: 100%;
  height: 0.8rem;
  line-height: 0.8rem;
  background-color: #d93c3a;
  font-size: 0.32rem;
  font-weight: 500;
  color: #ffffff;
  border-radius: 0.08rem;
}

.bottom {
  margin: 0.3rem -0.1rem 0;
  font-family: PingFangSC, PingFangSC-Regular;
  font-size: 0.24rem;
  font-weight: 400;
  text-align: center;
  color: #8884e9;
  line-height: 0.4rem;
  display: block;
  white-space: pre-line;
}

.section_1 {
  position: relative;
  width: 8.22rem;
  height: 4.94rem;
}

.label_1 {
  width: 0.44rem;
  height: 0.44rem;
  margin-top: 0.02rem;
}

.text-wrapper_1 {
  background-color: rgba(255, 255, 255, 0.17);
  border-radius: 5px;
  height: 0.76rem;
  border: 1px solid rgba(255, 255, 255, 0.32);
  margin-left: 0.4rem;
  width: 2rem;
}

.text_8 {
  width: 1.68rem;
  height: 0.34rem;
  overflow-wrap: break-word;
  color: rgba(0, 0, 0, 1);
  font-size: 0.4rem;
  text-align: right;
  white-space: nowrap;
  line-height: 0.34rem;
}

.bottom_icon {
  width: 12px;
  height: 15px;
  background-size: cover;
  filter: hue-rotate(100deg);
}

.text-group_1 {
  width: 276px;
  height: 17px;
  overflow-wrap: break-word;
  color: rgba(153, 153, 153, 1);
  font-size: 12px;
  text-align: left;
  white-space: nowrap;
  line-height: 15px;
}

::v-deep {
  .van-field__label {
    font-family: Alibaba PuHuiTi, serif;
    font-size: 0.28rem;
    color: #000000;
    margin-left: 0.2rem;
  }

  .van-progress__pivot {
    font-size: 12px;
    background-color: #d93c3a;
  }

  .van-progress__portion {
    background-color: #d93c3a;
  }

  .van-field__control {
    font-size: 0.28rem;
  }

  .van-field__control:disabled {
    -webkit-text-fill-color: #000000;
  }

  .van-checkbox__icon--checked .van-icon {
    background-color: white;
    border-color: #ed3f33 !important;
    color: #ed3f33;
  }
}
</style>
